import React, { useContext } from 'react'
import { Button, Col } from 'react-bootstrap'
import { Link } from 'react-router-dom';
import { FilterContext } from '../Context/FilterContext';


const List = ({ locations }) => {
  const { restaurants } = useContext(FilterContext)
  // console.log(restaurants);

  return (
    <React.Fragment>
      <Col sm={12} md={7} lg={8} className='list-box' >


        {
          !restaurants ? (
            <h2>Loading...</h2>
          ) : (
            restaurants.length < 1 ? (
              <h1 className='text-danger h-100 m-auto'>No Data For Filter</h1>
            ) : (
              restaurants.map((restaurant, index) => {
                return (
                  <div className="meal-list w-100" key={restaurant.restaurant_id}>
                    <div className="list-top d-flex">
                      <div className="img w-25 h-100">
                        <img src={restaurant.restaurant_thumb} alt={restaurant.restaurant_name} className='w-100 h-100' />
                      </div>
                      <div className="desc w-75 ms-2">
                        <h3 className="meal-title">
                          {restaurant.restaurant_name}
                        </h3>
                        <h6 className="city">
                          FORT {locations.state}
                        </h6>
                        <p className="address">
                          {restaurant.address}
                        </p>

                      </div>
                    </div>

                    <div className="list-bottom d-flex flex-column">
                      <div className="cost d-flex">
                        <h6 className="gray w-25">
                          CUISINES:
                        </h6>
                        <h6 className="dark">
                          {restaurant.cuisines[0].cuisine_name}, {restaurant.cuisines[1].cuisine_name}
                        </h6>
                      </div>
                      <div className="cost d-flex mt-3">
                        <h6 className="gray w-25">
                          COST FOR TWO:
                        </h6>
                        <h6 className="dark">
                          {restaurant.cost}
                        </h6>
                      </div>
                      <div className="proceed">
                        <Link to={`/detail/${restaurant.restaurant_id}`}>
                          <Button>Proceed</Button>
                        </Link>
                      </div>


                    </div>
                  </div>
                )
              })

            )
          )
        }



      </Col>
    </React.Fragment>
  )
}

export default List